import { service as request } from '@/libs/request'
import { Message } from 'element-ui'

/**
 * 高级 AI 数字员工 —— 接口封装
 *
 * ★前端只跟 PHP 说话，完全不需要知道 hms-agent-base（AI 工作流服务）的存在：
 *   事件流全存在 PHP 库里，刷新页面靠重放，不依赖 AI 服务在线。
 *
 * ★这里统一拆包（{code,msg,data} → data），组件里就不用到处 if (res.code === 0)。
 *   业务失败会弹提示并抛错，调用方用 try/catch 或让它冒泡即可。
 */
async function post(url, data) {
  const res = await request.post(url, data)
  // 拦截器在网络异常时已经弹过提示并返回 null
  if (!res) throw new Error('network error')
  if (res.code !== 0) {
    Message.error(res.msg || '操作失败')
    throw new Error(res.msg || 'business error')
  }
  return res.data
}

/** 员工列表（含 formSchema —— 表单由后端定义、前端动态渲染） */
export const employeeListApi = (data = {}) =>
  post('useragent/api.AdvancedEmployee/list', data)

/** 工作列表（左侧，当前用户 + 时间倒序） */
export const employeeTaskListApi = (data) =>
  post('useragent/api.AdvancedEmployee/taskList', data)

/** 发起一次生成 */
export const employeeStartApi = (data) =>
  post('useragent/api.AdvancedEmployee/start', data)

/** 任务详情：任务本体 + 全部事件（刷新页面 / 点历史任务时重建整屏） */
export const employeeTaskDetailApi = (data) =>
  post('useragent/api.AdvancedEmployee/taskDetail', data)

/**
 * 增量拉事件（轮询用）。
 * ★带上次拿到的最大 id 作游标 —— 断线、刷新、换设备都不会丢事件，也不会重复。
 */
export const employeeProgressApi = (data) =>
  post('useragent/api.AdvancedEmployee/progress', data)

/** 闸门确认 / 提修改意见 */
export const employeeReviewApi = (data) =>
  post('useragent/api.AdvancedEmployee/review', data)

/**
 * 「再改一版」—— 定稿之后回来改文案。**免费**。
 * ★靠上次存的决策快照跳过生图，只重渲受影响的页；没有它，定稿就等于锁死。
 */
export const employeeReviseApi = (data) =>
  post('useragent/api.AdvancedEmployee/revise', data)
